import { RequestPayload, ResponseData } from '../dtos/generic'

export function defineRoute<
  TMethod extends 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
  TResponse extends ResponseData<unknown>,
  TRequest extends RequestPayload<unknown> = TMethod extends 'GET' | 'DELETE' ? never : RequestPayload<unknown>,
>(def: {
  path: string
}): {
  path: string
  getPath: (options?: Record<string, string>) => string
  response: TResponse
} & (TMethod extends 'GET' | 'DELETE' ? object : { request: TRequest }) {
  return {
    ...def,
    getPath: (options) => (options ? interpolatePath(def.path, options) : def.path),
    request: {} as TRequest,
    response: {} as TResponse,
  }
}

function interpolatePath(path: string, options: Record<string, string>) {
  return path.replace(/:(\w+)/g, (match, p1: string) => options[p1] || match)
}
